import { inject, Pipe, PipeTransform } from '@angular/core';
import { PipedContentService } from '@empathy/survey-core';

import { SurveyViewerService } from '../services/survey-viewer.service';

@Pipe({
  name: 'content'
})
export class ContentPipe implements PipeTransform {
  private pipedContentService = inject(PipedContentService);
  private surveyViewerService = inject(SurveyViewerService);

  transform(text: string, qId?: string): string {
    const questionsCtrls = this.surveyViewerService.questionControls;
    const questions = this.surveyViewerService.questions;

    return this.pipedContentService.mapPipedContentFromControl(questions, questionsCtrls, text, qId);
  }
}
